<section class="treatment-subject-wrapper">
  <div class="left-panel-container">
    <h3 class="reflex-warning" *ngIf="reflexMessage">{{reflexMessage}}</h3>
    <ng-container [ngSwitch]="aberrationsGroup.selectionResourceConfig.type"
                  *ngFor="let aberrationsGroup of aberrationGroupsByResource$|async; trackBy: trackByIndex; let i = index"
    >
      <gen-treatment-subject-list *ngSwitchCase="'list'"
                                  [ngClass]="{'single-subject-list': true,'vertical-layout': (testConfig$|async).testViewVerticalLayout}"
                                  [autoSelect]="true"
                                  [isEditable]="isEditable"
                                  [showInReportToggleActive]="showInReportToggleActive"
                                  [showInMIToggleActive]="showInMIToggleActive"
                                  [subjectId]="subjectId"
                                  [therapiesGroups]="aberrationsGroup.therapiesGroups"
                                  [subjectListConfig]="aberrationsGroup.selectionResourceConfig"
                                  [molecularFinding] = "molecularFindingToMI"
                                  [editVisible]="editVisible"
                                  [formId]="formId"
                                  (onSubjectInit)="setInitSubjectId($event, aberrationsGroup?.selectionResourceConfig?.subjectIdPath, aberrationsGroup?.selectionResourceConfig?.name)"
                                  (onSubjectSelect)="setSubjectId($event, aberrationsGroup?.selectionResourceConfig?.subjectIdPath, aberrationsGroup?.selectionResourceConfig?.name)"
                                  (onchangeOpinionOfMI)="changeOpinionOfMI($event)"
      ></gen-treatment-subject-list>
      <ng-container *ngSwitchCase="'flow'">
        <ng-container *ngIf="!isNewPanelConfigured(aberrationsGroup?.selectionResourceConfig?.LeftPanelNewLayout)" >
          <ng-container *ngTemplateOutlet="oldPanelLayout"></ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'form'">
        <gen-dynamic-form
                class="subject-form"
                [formData]="aberrationsGroup?.selectionResourceConfig?.payload?.formData"
                [formConfig]="aberrationsGroup?.selectionResourceConfig?.payload?.formConfig"
                [formName]="aberrationsGroup?.selectionResourceConfig?.payload?.formId"
                [submitButtonText]="aberrationsGroup?.selectionResourceConfig?.payload?.submitButtonText"
                [cancelButtonText]="aberrationsGroup?.selectionResourceConfig?.payload?.cancelButtonText"
                [disabled]="aberrationsGroup?.selectionResourceConfig?.payload?.disabled"
                [listenToDataChange]="aberrationsGroup?.selectionResourceConfig?.payload?.listenToDataChange"
        ></gen-dynamic-form>
      </ng-container>

    </ng-container>
  </div>
</section>

<ng-template #oldPanelLayout >
  <ispm-pathways-list></ispm-pathways-list>
  <div><hr class="horizontal-separator"></div>
  <gen-smart-note>
    <div dynamicTitle class="tp-note-title">Treatment selection notes</div>
  </gen-smart-note>
</ng-template>
